import React from 'react';
import {getOutlet} from 'reconnect.js';
import LoginModal from 'rev.sdk.js/Components/LoginModal';
import ResetPasswordModal from '../Components/ResetPasswordModal';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import {buildCatDisplayMap} from 'rev.sdk.js/Utils/buildCatDisplayMap';
import useDetectDimension from 'rev.sdk.js/Hooks/useDetectDimension';
import Spinner from 'rev.sdk.js/Components/Spinner';

function Provider(props) {
  useDetectDimension();

  React.useEffect(() => {
    console.log('AppCtx effect hook');
    function onCtxRendered() {
      JStorage.fetchDocuments('site', {}, null, null).then((configs) => {
        for (const cfg of configs) {
          if (cfg.name === 'product_category') {
            cfg.categories.meta_data = {...cfg.meta_data};
            getOutlet('categories').update(cfg.categories || []);
            getOutlet('categoryDisplayMap').update(
              buildCatDisplayMap(cfg.categories || []),
            );
          } else if (cfg.name === 'article_category') {
            cfg.categories.meta_data = {...cfg.meta_data};
            getOutlet('articleCategories').update(cfg.categories || []);
            getOutlet('articleCategoryDisplayMap').update(
              buildCatDisplayMap(cfg.categories || []),
            );
          }
        }
      });
    }

    onCtxRendered();
  }, []);

  console.log('AppCtx rendered');

  return (
    <>
      {props.children}

      <LoginModal />
      <ResetPasswordModal />
      <Spinner blur={true} />
    </>
  );
}

export {Provider};
